import { useCallback } from 'react';
/**
 * Allows you to merge refs with a callback ref
 *
 * @param refs to merge
 * @returns CallbackRef
 */
export function useRefMerger(...refs) {
    return useCallback(current => {
        refs.forEach(ref => {
            if (!ref)
                return;
            if (typeof ref === 'function') {
                ref(current);
            }
            else {
                ref.current = current;
            }
        });
        // the spread is a new array, we only want it to change when refs change
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
//# sourceMappingURL=useRefMerger.js.map